import { Checkbox } from "../../components/Checkbox";
import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { sameNodePosition } from "../../components/markdown/utils";
import { assertNever } from "../../lib/utils";
import React, { memo } from "react";
/**
 * Renders `<input>` elements inside Markdown output; checkboxes (as produced
 * by GitHub Flavored Markdown task lists) are swapped for the Sparkle Checkbox component, or
 * dropped when the "step" task-list variant draws its own badge; other input
 * types pass through unchanged.
 * @summary Input renderer for Markdown task-list checkboxes.
 */
export const InputBlock = memo(({
  type,
  checked,
  className,
  onChange,
  ref,
  ...props
}) => {
  const inputRef = React.useRef(null);
  React.useImperativeHandle(ref, () => inputRef.current);
  const {
    taskListVariant
  } = useMarkdownStyle();
  if (type !== "checkbox") {
    return /*#__PURE__*/React.createElement("input", {
      ref: inputRef,
      type: type,
      checked: checked,
      className: className,
      ...props
    });
  }
  switch (taskListVariant) {
    case "step":
      return null;
    case "checkbox":
      break;
    default:
      assertNever(taskListVariant);
  }
  const handleCheckedChange = isChecked => {
    onChange === null || onChange === void 0 || onChange({
      target: {
        type: "checkbox",
        checked: isChecked
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-flex items-center"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    ref: inputRef,
    checked: checked,
    className: "translate-y-[3px]",
    onCheckedChange: handleCheckedChange
  }));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.type === next.type && prev.checked === next.checked && prev.className === next.className);
InputBlock.displayName = "InputBlock";
//# sourceMappingURL=InputBlock.js.map